(function () {

	'use strict';

	angular
		.module('AutoPrequal')
		.directive('tooltip', ['$timeout', '$window', function ($timeout, $window) {
			return {
				replace: true,
				templateUrl: baseUrl + 'root/app/views/tooltip.tpl.html',
				restrict: 'E',
				scope: {
					content: "@",
					direction: "=",
					a11y: "@",
					iden: "@"
				},
				link: function (scope, elem, attrs) {

					scope.expand = function () {
						if (scope.showTooltip) {
							scope.$eval(attrs.onExpand);
							$timeout(function () {
								setStyle();
							});
						}
					}

					function setStyle() {

						var containerWidth = $(elem).parents(".container-right-inner")[0].clientWidth;
						var tooltipOffsetLeft = Math.max(-475, $(elem).parents(".container-right-inner").offset().left - $(elem).offset().left);

						scope.tooltipStyle = {
							"width": (containerWidth - 15) + "px",
							"margin-left": tooltipOffsetLeft + 7.5 + "px",
							"max-width": "500px"
						};
					}

					$timeout(function () {
						setStyle();
					});

					angular.element($window).bind('resize', function () {
						setStyle();
					});
				}
			}
		}]);

})();
